import React from 'react'
import { BrowserRouter as Router } from 'react-router-dom';
import { AppRouter } from './routes/routes';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {UserProvider} from "../entities/user/model/UserContext.jsx";
import Snowfall from 'react-snowfall';



class App extends React.Component {
  render () {

      return (
        <>
            <Router>
              <UserProvider>
                  <AppRouter />
              </UserProvider>
            </Router>

          <ToastContainer
              closeOnClick
              position="top-right"
              autoClose={3000}
          />
        </>
    )
  }
}

export default App